import React from 'react';

const NotificationDot = () => (
  <div className="absolute right-0 top-0 h-2.5 w-2.5 rounded-full bg-red-300 shadow-sm shadow-red-400"></div>
);

export default NotificationDot;